import { memo } from 'react';

import { TriangleAlertIcon } from '@air/design-icons';
import { tailwindVariants } from '@air/utils-tailwind';

import { type CreditUsageState } from '~/components/CreditUsageMeter/types';

const creditUsageWarningBannerVariants = tailwindVariants({
  slots: {
    banner: 'flex items-center justify-center gap-1 rounded-t-8 px-3 py-2.5',
    bannerIcon: 'size-3',
    bannerText: 'text-12',
  },
  variants: {
    usageState: {
      default: {
        banner: '',
        bannerIcon: '',
        bannerText: '',
      },
      '95%': {
        banner: 'ads:bg-error-subtle bg-flash-4',
        bannerIcon: 'ads:text-icon-error text-flash-11',
        bannerText: 'ads:text-error text-flash-12',
      },
      depleted: {
        banner: 'ads:bg-error-subtle bg-flash-4',
        bannerIcon: 'ads:text-icon-error text-flash-11',
        bannerText: 'ads:text-error text-flash-12',
      },
    },
  },
});

export type CreditUsageWarningBannerProps = {
  percentageUsed: number;
  usageState: CreditUsageState;
};

export const CreditUsageWarningBanner = memo(({ percentageUsed, usageState }: CreditUsageWarningBannerProps) => {
  if (usageState === 'default') {
    return null;
  }

  const styles = creditUsageWarningBannerVariants({ usageState });

  return (
    <div className={styles.banner()}>
      <TriangleAlertIcon className={styles.bannerIcon()} />
      <span className={styles.bannerText()}>
        {usageState === 'depleted' ? "You've depleted your credits" : `You've used ${percentageUsed}% of your credits`}
      </span>
    </div>
  );
});

CreditUsageWarningBanner.displayName = 'CreditUsageWarningBanner';
